<template>
  <div class="card">
    <div class="card-header">
      <h5 v-html="Translate('@_ABOUT')"></h5>
    </div>
    <div class="card-body">
      <fieldset>
        <div class="row">
          <div class="col-12">Version: {{settings.version}}</div>
        </div>
      </fieldset>
      <fieldset>
        <div class="row">          
          <div class="col-12 font-weight-light" style="font-size:12px;">Επίβλεψη: Ιορδάνης Κιοσκερίδης - Ευκλείδης Κεραμόπουλος</div>
          <div class="col-12 font-weight-light" style="font-size:12px;">Επικοινωνία: ikiosker@el.teithe.gr - euclidk@gmail.com</div>
          <br/>
          <div class="col-12 font-weight-light" style="font-size:12px;">Υλοποίηση: Κυριάκος Τσιακμάκης - Αναστάσιος Οικονόμου</div>
        </div>
      </fieldset>
    </div>
    <div class="card-header"  v-if="isAdmin || isTeacher">
      <h5 v-html="'Οδηγίες'"></h5>
    </div>
    <div class="card-body"  v-if="isAdmin || isTeacher">
      <fieldset>
        <ul class="list-group">
          <li
            class="list-group-item"
            v-html="'O επιβλέπων μπορεί να αλλάξει την λίστα με τα προαπαιτούμενα μαθήματα μόνο στις Καταστάσεις:'+Translate('@_THESIS_STATUS_AVAILABLE')+', '+Translate('@_THESIS_STATUS_TAKEN')"
          ></li>
          <li
            class="list-group-item"
            v-html="'O Admin μπορεί να αλλάξει την λίστα με τα προαπαιτούμενα μαθήματα μόνο στις Καταστάσεις:'+Translate('@_THESIS_STATUS_AVAILABLE')+', '+Translate('@_THESIS_STATUS_TAKEN')+', '+Translate('@_THESIS_STATUS_PENDINGFORAPPROVAL')+', '+Translate('@_THESIS_STATUS_APPROVEDANDWAITINGTOPRESENT')+', '+Translate('@_THESIS_STATUS_PENDINGFOREXAMANDGRADING')"
          ></li>
          <li
            class="list-group-item"
            v-html="'O επιβλέπων μπορεί να διαγράψει την Διπλωματική μόνο στις Καταστάσεις:'+Translate('@_THESIS_STATUS_AVAILABLE')"
          ></li>
          <li
            class="list-group-item"
            v-html="'O Admin μπορεί να διαγράψει την Διπλωματική μόνο στις Καταστάσεις:'+Translate('@_THESIS_STATUS_AVAILABLE')+', '+Translate('@_THESIS_STATUS_TAKEN')+', '+Translate('@_THESIS_STATUS_PENDINGFORAPPROVAL')+', '+Translate('@_THESIS_STATUS_APPROVEDANDWAITINGTOPRESENT')+', '+Translate('@_THESIS_STATUS_PENDINGFOREXAMANDGRADING')"
          ></li>
          <li class="list-group-item" v-html="'...'"></li>
        </ul>
      </fieldset>
      <fieldset>
        <h5>Καταστάσεις Διπλωματικής</h5>
        <li class="list-group-item" v-html="'1:'+Translate('@_THESIS_STATUS_AVAILABLE')"></li>
        <li class="list-group-item" v-html="'2:'+Translate('@_THESIS_STATUS_TAKEN')"></li>
        <li class="list-group-item" v-html="'3:'+Translate('@_THESIS_STATUS_PENDINGFORAPPROVAL')"></li>
        <li
          class="list-group-item"
          v-html="'4:'+Translate('@_THESIS_STATUS_APPROVEDANDWAITINGTOPRESENT')"
        ></li>
        <li
          class="list-group-item"
          v-html="'5:'+Translate('@_THESIS_STATUS_PENDINGFOREXAMANDGRADING')"
        ></li>
        <li class="list-group-item" v-html="'6:'+Translate('@_THESIS_STATUS_COMPLETED')"></li>
        <li class="list-group-item" v-html="'7:'+Translate('@_THESIS_STATUS_CANCELED')"></li>
      </fieldset>
    </div>
  </div>
</template>

<script>
import Mixin from "@/helpers/mixin";

export default {
  name: "Profile",
  mixins: [Mixin]
};
</script>

<style scoped></style>
